export const substractHoursFromDate = ({ hours, date = new Date() }: { hours: number; date?: Date }): Date => {
  const dateCopy = new Date(date.getTime());
  dateCopy.setTime(dateCopy.getTime() - hours * 60 * 60 * 1000);
  return dateCopy;
};
